import React from 'react'
import './CustomerDashboardOrderDetails.scss'

const CustomerDashboardOrderDetails = () => {
  return (
    <div>CustomerDashboardOrderDetails</div>
  )
}

export default CustomerDashboardOrderDetails